import { PageWrapper } from 'src/client/components/PageWrapper';
import { TeamCreate } from 'src/client/components/TeamCreate';

export const TeamsCreatePage = (): JSX.Element => (
    <PageWrapper title="My Team">
        <TeamCreate />
    </PageWrapper>
);
